import utils from '@/utils';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getPlants: () => {
		return client
			.get(`${BASE_URL}/cc/v1/plant`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getCommCodes: param => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/${param.plantCd}/commonCodes?commCdType=${param.codeType}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getUsers: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		if (searchParams.userId !== undefined || searchParams.userName !== undefined || searchParams.useYn !== undefined) {
			queryStr = utils.objectToQueryString({
				userId: searchParams.userId,
				userName: searchParams.userName,
				useYn: searchParams.useYn,
				currentPage,
				pageUnit
			});
		}
		return client
			.get(`${BASE_URL}/user/v1/users` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getGroups: param => {
		let queryStr = utils.objectToQueryString({
			useYn: 'Y'
		});
		return client
			.get(`${BASE_URL}/userGroup/v1/plants/${param.plantCd}/groups` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getUserMappingGroups: param => {
		return client
			.get(`${BASE_URL}/userMapping/v1/users/${param.userId}/groups`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	postGroups: param => {
		return client
			.post(`${BASE_URL}/userMapping/v1/status/${param.status}/plants/${param.plantCd}/users/${param.userId}/groups`, param.data)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
